module.exports = __webpack_public_path__ + "b4c4f7d729dd2f59627bc8171f2f2853.gltf";